export enum VehicleTypeEnum {
    TRACTOR = 'tractor',
    SEMITRAILER = 'semitrailer',
    DOLLY = 'dolly', // means balancin
    SEMI = 'semi',
    INLOADER = 'inloader',
    LOWBOY = 'lowboy', // means carreton
}
